<div class="mt-2 mb-2" *ngIf="useDetailAddButton">
  <p-button [outlined]="true"  class="p-button-outlined p-button-secondary p-button-sm right mr-2" styleClass="height:25px;margin-left: 3px;" severity="danger"
  label="Delete" icon="pi pi-trash" iconPos="left" *ngIf="selectionCount > 0"
  (onClick)="onDeleteClick($event)"></p-button>
</div>
